import Helper from "./Helper";
import Swiper from "../lib/swiper";

class SliderHandler {
  constructor(config = {}) {
    const {
      sliderType,
      outerWrapperSelector,
      sliderContainerSelector,
      sliderPaginationselector,
      sliderPrevSelector,
      sliderNextSelector,
      sliderBreakpoint,
    } = config;
    this.sliderType = sliderType;
    this.outerWrapperSelector = outerWrapperSelector;
    this.sliderContainerSelector =
      sliderContainerSelector || ".swiper-container";
    this.sliderPaginationselector =
      sliderPaginationselector || ".swiper-pagination";
    this.sliderPrevSelector = sliderPrevSelector || ".swiper-button-prev";
    this.sliderNextSelector = sliderNextSelector || ".swiper-button-next";
    this.sliderBreakpoint = sliderBreakpoint || 768;

    this.sliders = document.querySelectorAll(this.outerWrapperSelector);
    this.slidersArray = Array.prototype.slice.call(this.sliders);

    this.currentScreenWidth = window.innerWidth;
    this.previousScreenWidth = window.innerWidth;
    this.sliderIsInitiated = false;
    this.currentlyDesktop = "";
    this.swiperInstances = [];

    if (this.sliders) {
      this.bindEvents();
    }
  }

  bindEvents() {
    if (this.currentScreenWidth < this.sliderBreakpoint) {
      this.currentlyDesktop = false;
      this.initSwipersMobile();
    } else {
      this.currentlyDesktop = true;
      this.initSwipersDesktop();
    }

    window.addEventListener("resize", () => {
      const vw = window.innerWidth;

      // console.log(this.currentlyDesktop);

      if (this.previousScreenWidth < this.sliderBreakpoint) {
        if (vw > this.sliderBreakpoint) {
          // console.log("breakpoint change");
          this.destroySwipers();
          this.initSwipersDesktop();
        }
      }

      if (this.previousScreenWidth > this.sliderBreakpoint) {
        if (vw < this.sliderBreakpoint) {
          // console.log("breakpoint change");
          this.destroySwipers();
          this.initSwipersMobile();
        }
      }

      this.previousScreenWidth = vw;
    });
  }

  initSwipersDesktop() {
    // console.log("desktop");
    this.slidersArray.forEach((slider, index) => {
      const swiperContainer = slider.querySelector(
        this.sliderContainerSelector
      );
      let swiperConfig = {};
      if (this.sliderType == "slideWithTab") {
        // console.log("header");
        const swiperNav = [];
        const slides = Array.prototype.slice.call(
          slider.querySelectorAll(".swiper-slide")
        );
        slides.forEach((slide, index) => {
          const slideInfo = [];
          slideInfo.title = slide.querySelector(
            ".slide-pagination-title"
          ).innerText;
          swiperNav["slide-" + index] = slideInfo;
        });
        swiperConfig = {
          speed: 600,
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true,
          autoplay: false,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
              return (
                `<span class="${className} custom-pagination-bullet">
                  <span class="title">${swiperNav["slide-" + index].title}</span>
                </span>`
              );
            }
          },
        };
      } else if (this.sliderType == "keyfigures") {
        swiperConfig = {
          speed: 600,
          slidesPerView: 4,
          spaceBetween: 30,
          loop: true,
          autoplay: true
        };
      }
      const instance = new Swiper(swiperContainer, swiperConfig);
      this.swiperInstances.push(instance);
    });
  }

  initSwipersMobile() {
    // console.log("mobile");
    this.slidersArray.forEach((slider, index) => {
      const swiperContainer = slider.querySelector(
        this.sliderContainerSelector
      );
      let swiperConfig = {};
      if (this.sliderType == "slideWithTab") {
        const swiperNav = [];
        const slides = Array.prototype.slice.call(
          slider.querySelectorAll(".swiper-slide")
        );
        slides.forEach((slide, index) => {
          const slideInfo = [];
          slideInfo.title = slide.querySelector(
            ".slide-pagination-title"
          ).innerText;
          swiperNav["slide-" + index] = slideInfo;
        });
        swiperConfig = {
          speed: 600,
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true,
          autoplay: false,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
              return (
                `<span class="${className} custom-pagination-bullet">
                  <span class="title">${swiperNav["slide-" + index].title}</span>
                </span>`
              );
            }
          },
        };

        // swiperConfig = {
        //   speed: 600,
        //   parallax: true,
        //   loop: true,
        //   autoplay: false,
        //   centeredSlides: true,
        //   navigation: {
        //     nextEl: ".swiper-button-next",
        //     prevEl: ".swiper-button-prev",
        //   },
        //   pagination: {
        //     el: ".swiper-pagination",
        //     clickable: true,
        //     // dynamicBullets: true,
        //   },
        // };
      } else if (this.sliderType == "keyfigures") {
        swiperConfig = {
          speed: 600,
          slidesPerView: 4,
          spaceBetween: 30,
          loop: true,
          autoplay: true
        };
      }
      const instance = new Swiper(swiperContainer, swiperConfig);
      this.swiperInstances.push(instance);
    });
  }

  destroySwipers() {
    // console.log(this.swiperInstances);
    // console.log("destroy");
    this.swiperInstances.forEach((instance) => {
      instance.destroy(true, true);
    });
  }

  getInstances() {
    return this.swiperInstances;
  }
}

export default SliderHandler;
